/// <reference path="../native.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { createElement, ReactElement, ReactNode } from "react";
import HardwareScannerPreview from "./Components/HardwareScannerPreview";
import { IScanner, IScannerCode, IScanOptions } from "./Abstraction/IScanner";
import { appSettings } from "../AppSettings";


export class NativeScanner implements IScanner {

    protected _scanPromise: (code: IScannerCode) => void;

    constructor() {
        this.isScanning = false;
        this.isOpen = false;
    }

    /**************************************/

    async closeAsync() {

        if (!this.isOpen)
            return;

        await this.stopScanAsync();

        scanner.close();

        this.isOpen = false;

        console.debug("SCAN CLOSED");
    }

    /**************************************/

    async openAsync(force = false): Promise<void> {

        if (this.isOpen && !force)
            return;

        const res = scanner.open();

        if (!res) {
            console.error("SCANNER OPEN FAILED");
            return;
        }

        console.debug("OPEN OK: native");

        this.isOpen = true;
    }

    /**************************************/

    async startMultiScanAsync(onResult: (result: IScannerCode) => Promise<boolean>, options?: IScanOptions): Promise<void> {

        if (this.isScanning)
            return;

        this.isScanning = true;

        scanner.scannerOn();

        let lastCode: string;
        let lastCodeTime: number;

        var suspendCount = 0;

        window.onScanEnd = async (value: IScannerCode) => {

            console.log("onScanEnd ", suspendCount);

            if (suspendCount > 0)
                return;

            try {

                suspendCount++;

                const curTime = new Date().getTime();

                const timeout = appSettings.multiScanSameCodeTimeout;

                if (lastCodeTime && lastCode == value.code && (curTime - lastCodeTime) < timeout)
                    return;

                lastCodeTime = curTime;
                lastCode = value?.code;

                console.log("NATIVE CODE:" + value?.code)

                const continueScan = await onResult(value);

                if (!value?.code || !continueScan)
                    await this.closeAsync();


            }
            finally {
                suspendCount--;
                scanner.scannerOn();
            }
        }

        scanner.scannerOn();

        await new Promise(res => this._scanPromise = res);
        
        this._scanPromise = null;

        this.isScanning = false;

    }

    /**************************************/

    async scanSingleAsync(options?: IScanOptions): Promise<IScannerCode> {

        this.isScanning = true;

        console.debug("START SCANNING");

        const code = await new Promise<IScannerCode>((res) => {

            window.onScanEnd = (value) => {

                console.log('onScanEnd ', value.code);

                if (!this._scanPromise)
                    return;

                res(value);

                this._scanPromise = null;

                if (scanner.useNativeInterface())
                    this.closeAsync();
            }

            this._scanPromise = res;

            scanner.scannerOn();
        });

        console.debug("SCAN OK");

        this.isScanning = false;

        return code;
    }

    /**************************************/

    async stopScanAsync(): Promise<void> {

        console.debug("stopScanAsync ", this.isScanning);

        if (!this.isScanning)
            return;

        window.onScanEnd = () => false;

        scanner.scannerOff();

        if (this._scanPromise) {
            this._scanPromise(null);
            this._scanPromise = null;
        }

        this.isScanning = false; 
      

        console.debug("SCAN STOPPED");
    }

    /**************************************/

    createPreview(info?: ReactNode, isScanning?: boolean): ReactElement {

        if (scanner.useNativeInterface())
            return null;
        return createElement(HardwareScannerPreview, { scanner: this, info, isScanning });
    }

    /**************************************/

    onTrigger(handler: (isOn: boolean) => void): void {

        if (!handler)
            window.onScanTrigger = () => false;
        else
            window.onScanTrigger = value => handler(value.state);
    }


    /**************************************/

    onNewCode(handler: (value: IScannerCode) => void): void {
        console.log("Add onNewCodeHandler: " + (handler != null ? "yes": "no"))
        if (!handler)
            window.onNewCode = () => false;
        else
            window.onNewCode = handler;
    }

    /**************************************/

    isScanning: boolean;

    isOpen: boolean;
}